module.exports = __webpack_public_path__ + "static/media/trustpilot.3ba1b40f.png";